//  import React, { useContext, useEffect, useState } from "react";
// import { DataContext } from "../Screenss/DataContext";

// const StaffManagement = () => {
//   const primaryColor = "rgb(0,111,47)";
//   const { data } = useContext(DataContext);
//   const [current, setCurrent] = useState(0);

//   // 🔥 API DATA
//   const galleryItems = data.filter(
//     (item) => item.category === "schoolstaff"
//   );

//   // 🔁 AUTO SLIDER
//   useEffect(() => {
//     if (galleryItems.length === 0) return;

//     const interval = setInterval(() => {
//       setCurrent((prev) =>
//         prev === galleryItems.length - 1 ? 0 : prev + 1
//       );
//     }, 3000);

//     return () => clearInterval(interval);
//   }, [galleryItems]);

//   // 🔥 CONTENT CARDS
//   const points = [
//     "Highly Qualified Teachers",
//     "Experienced Management",
//     "Focus on Holistic Development",
//     "Strong Academic Foundation",
//   ];

//   return (
//     <div style={styles.page}>

//       {/* 🔥 TOP SLIDER */}
//       <section style={styles.hero}>
//         <div style={styles.heroImageWrap}>
//           {galleryItems.length > 0 && (
//             <img
//               src={galleryItems[current].full_url}
//               alt="staff"
//               style={styles.heroImage}
//             />
//           )}

//           {/* DOTS */}
//           <div style={styles.dots}>
//             {galleryItems.map((_, i) => (
//               <span
//                 key={i}
//                 onClick={() => setCurrent(i)}
//                 style={{
//                   ...styles.dot,
//                   backgroundColor:
//                     current === i ? primaryColor : "#fff",
//                 }}
//               />
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* 🔥 MAIN SECTION */}
//       <div style={styles.section}>
//         <h2 style={{ ...styles.heading, color: primaryColor }}>
//           Management & Staff
//         </h2>

//         {/* 🔥 MIX CARD GRID */}
//         <div style={styles.mixGrid}>

//           {/* 🟢 TEXT CARD (TOP LEFT) */}
//           <div style={styles.card}>
//             <div>
//               <h3 style={{ color: primaryColor, marginBottom: "10px" }}>
//                 Management & Staff
//               </h3>
//               <p style={styles.cardText}>
//                 Delhi Public Kids School, started in 2013 under Vadhera
//                 Shiksha Samiti, provides quality education with experienced
//                 and dedicated staff focused on overall development.
//               </p>
//             </div>
//           </div>

//           {/* 🖼 IMAGE 1 */}
//           {galleryItems[0] && (
//             <div style={styles.card}>
//               <img src={galleryItems[0].full_url} style={styles.cardImage} />
//             </div>
//           )}

//           {/* 🖼 IMAGE 2 */}
//           {galleryItems[1] && (
//             <div style={styles.card}>
//               <img src={galleryItems[1].full_url} style={styles.cardImage} />
//             </div>
//           )}

//           {/* 🖼 IMAGE 3 */}
//           {galleryItems[2] && (
//             <div style={styles.card}>
//               <img src={galleryItems[2].full_url} style={styles.cardImage} />
//             </div>
//           )}

//           {/* 🔥 CONTENT CARDS */}
//           {/* {points.map((item, i) => (
//             <div key={i} className="staff-card" style={styles.card}>
//               {item}
//             </div>
//           ))} */}

//         </div>
//       </div>

//       {/* 🔥 HOVER + RESPONSIVE */}
//       <style>{`
//         .staff-card:hover {
//           transform: translateY(-8px) scale(1.02);
//           background: ${primaryColor};
//           color: #fff;
//         }

//         @media (max-width: 768px) {
//           .mix-grid {
//             grid-template-columns: 1fr !important;
//           }
//         }
//       `}</style>

//     </div>
//   );
// };

// export default StaffManagement;



// /* ✅ STYLES */
// const styles = {
//   page: {
//     backgroundColor: "#fcfcfc",
//     fontFamily: "Poppins, sans-serif",
//   },

//   hero: {
//     marginTop: "120px",
//   },

//   heroImageWrap: {
//     height: "500px",
//     position: "relative",
//     overflow: "hidden",
//   },

//   heroImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },

//   dots: {
//     position: "absolute",
//     bottom: "20px",
//     left: "50%",
//     transform: "translateX(-50%)",
//     display: "flex",
//     gap: "8px",
//   },

//   dot: {
//     width: "10px",
//     height: "10px",
//     borderRadius: "50%",
//     cursor: "pointer",
//     border: "1px solid #ccc",
//   },

//   section: {
//     padding: "60px 20px",
//     maxWidth: "1100px",
//     margin: "auto",
//   },

//   heading: {
//     textAlign: "center",
//     fontSize: "2.4rem",
//     marginBottom: "40px",
//     fontWeight: "800",
//   },

//   /* 🔥 MAIN GRID */
//   mixGrid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(2, 1fr)",
//     gap: "20px",
//   },

//   /* 🔥 CARD SAME DESIGN */
//   card: {
//     background: "#fff",
//     borderRadius: "16px",
//     boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
//     overflow: "hidden",
//     minHeight: "220px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     padding: "20px",
//     textAlign: "center",
//     transition: "0.3s",
//   },

//   cardImage: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//   },

//   cardText: {
//     fontSize: "0.95rem",
//     color: "#555",
//     lineHeight: "1.6",
//   },
// };
import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../Screenss/DataContext";
import Footer from "../Screenss/Footer";
const StaffManagement = () => {
  const primaryColor = "rgb(0,111,47)";
  const { data } = useContext(DataContext);
  const [current, setCurrent] = useState(0);

  // 🔥 API DATA
  const galleryItems = data.filter((item) => item.category === "schoolstaff");

  // 🔁 AUTO SLIDER
  useEffect(() => {
    if (galleryItems.length === 0) return;
    const interval = setInterval(() => {
      setCurrent((prev) => (prev === galleryItems.length - 1 ? 0 : prev + 1));
    }, 3000);
    return () => clearInterval(interval);
  }, [galleryItems]);

  return (
    <div style={styles.page}>
      {/* 🔥 HERO SECTION */}
      <section style={styles.hero}>
        <div style={styles.heroImageWrap}>
          {galleryItems.length > 0 && (
            <img
              src={galleryItems[current].full_url}
              alt="staff hero"
              style={styles.heroImage}
            />
          )}
          <div style={styles.dots}>
            {galleryItems.map((_, i) => (
              <span
                key={i}
                onClick={() => setCurrent(i)}
                style={{
                  ...styles.dot,
                  backgroundColor: current === i ? primaryColor : "#fff",
                }}
              />
            ))}
          </div>
        </div>
      </section>

      {/* 🔥 MAIN SECTION */}
      <div style={styles.section}>
        {/* <h2 style={{ ...styles.heading, color: primaryColor }}>
          Management & Staff
        </h2> */}

        {/* 🔥 RESPONSIVE MIX GRID */}
        <div className="staff-grid-layout" style={styles.mixGrid}>
          
          {/* 🟢 TEXT CARD */}
          <div className="staff-card" style={styles.card}>
            <div>
              <h3 style={{ color: primaryColor, marginBottom: "10px" }}>
                Management & Staff
              </h3>
              <p style={styles.cardText}>
                Delhi Public Kids School, started in 2013 under Vadhera
                Shiksha Samiti, provides quality education with experienced
                and dedicated staff focused on overall development.
              </p>
            </div>
          </div>

          {/* 🖼️ IMAGES FROM API */}
          {galleryItems.map((item, index) => (
            <div key={index} className="staff-card" style={styles.card}>
              <img src={item.full_url} alt="Staff Member" style={styles.cardImage} />
            </div>
          ))}

        </div>
     
      </div>

      {/* 🔥 CSS FOR RESPONSIVENESS & HOVER */}
      <style>{`
        /* Desktop: 2 Columns | Mobile: 1 Column */
        .staff-grid-layout {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
        }

        .staff-card {
          transition: 0.3s ease;
        }

        .staff-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 15px 35px rgba(0,0,0,0.12);
        }

        @media (max-width: 768px) {
          .staff-grid-layout {
            grid-template-columns: 1fr !important; /* Mobile par single column */
          }
          .hero-image-wrap {
            height: 300px !important; /* Mobile par hero ki height kam */
          }
          .staff-heading {
            font-size: 1.8rem !important;
          }
        }
      `}</style>
          
    </div>
  );
};

/* ✅ STYLES */
const styles = {
  page: { backgroundColor: "#fcfcfc", fontFamily: "'Poppins', sans-serif" },
 hero: {
    width: "100%",
    marginTop: "clamp(80px, 10vw, 120px)", // 🔥 responsive
  },

  heroImageWrap: {
    position: "relative",
    width: "100%",
    height: "clamp(260px, 50vw, 560px)", // 🔥 FIXED → responsive
    overflow: "hidden",
    marginTop: "clamp(60px, 8vw, 140px)", // 🔥 responsive
  },

  heroImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
  dots: {
    position: "absolute",
    bottom: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    gap: "8px",
  },
  dot: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    cursor: "pointer",
    border: "1px solid #ccc",
    transition: "0.3s"
  },
  section: { padding: "60px 20px", maxWidth: "1100px", margin: "auto" },
  heading: { textAlign: "center", fontSize: "2.4rem", marginBottom: "40px", fontWeight: "800" },
  
  mixGrid: {
    // Layout handled by <style> tag for responsiveness
  },
  
  card: {
    background: "#fff",
    borderRadius: "16px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
    overflow: "hidden",
    minHeight: "250px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0", // Images pure card par aayein
    textAlign: "center",
  },
  cardImage: { width: "100%", height: "100%", objectFit: "cover", display: "block" },
  cardText: { fontSize: "1rem", color: "#555", lineHeight: "1.7", padding: "25px" },
};

export default StaffManagement;